import AlertDetailsBlockComponent from './AlertDetailsBlock/AlertDetailsBlock'
import FalsesPositivesBlockComponent from './FalsesPositivesBlock/FalsesPositivesBlock'
import UserDetailsBlockComponent from './UserDetailsBlock/UserDetailsBlock'


export const AlertDetailsBlock = AlertDetailsBlockComponent
export const FalsesPositivesBlock = FalsesPositivesBlockComponent
export const UserDetailsBlock = UserDetailsBlockComponent
